(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      //console.log('StickyHeader constructor');
    }

    connectedCallback() {
      //console.log('StickyHeader connectedCallback');
      this.header = document.querySelector('sticky-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // dummy-headerを作成してヘッダーの前に挿入し、非表示に設定
      this.dummyHeader = document.createElement('div');
      this.dummyHeader.classList.add('dummy-header');
      this.dummyHeader.style.height = '64px'; // 高さを64pxに固定
      this.dummyHeader.style.display = 'none';
      this.header.parentNode.insertBefore(this.dummyHeader, this.header);
      //console.log('dummy-header created and inserted');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      //console.log('setHeaderHeight');
      const headerHeight = 64; // 高さを64pxに固定
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      this.dummyHeader.style.height = `${headerHeight}px`;
      //console.log('dummy-header height set to:', headerHeight);
    }

    disconnectedCallback() {
      //console.log('StickyHeader disconnectedCallback');
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      //console.log('createObserver');
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.dummyHeader.style.display = 'block'; // dummy-headerを表示
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.dummyHeader.style.display = 'block'; // dummy-headerを表示
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.dummyHeader.style.display = 'none'; // dummy-headerを非表示
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      //console.log('hide');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.dummyHeader.style.display = 'block'; // dummy-headerを表示
      //console.log('dummy-header displayed');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      //console.log('reveal');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      //console.log('dummy-header displayed');
    }

    reset() {
      //console.log('reset');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.dummyHeader.style.display = 'none'; // dummy-headerを非表示
      //console.log('dummy-header hidden');
    }

    closeMenuDisclosure() {
      //console.log('closeMenuDisclosure');
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      //console.log('closeSearchModal');
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
